module.exports = __webpack_public_path__ + "static/fonts/iconfont.81e28edd.ttf";